/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * VyV BackOffice API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {
  HttpClient,
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpParameterCodec,
  HttpParams,
  HttpResponse,
} from "@angular/common/http";
import { Inject, Injectable, Optional } from "@angular/core";
import { Observable } from "rxjs";
import { CustomHttpParameterCodec } from "../encoder";

// @ts-ignore
import { ProductCodeVm, ProductMenuVM } from "../model/productMenuVM";

// @ts-ignore
import { BaremeResponse } from "src/app/api/model/baremeResponse";
import { environment } from "src/environments/environment";
import { Configuration } from "../configuration";
import { BASE_PATH } from "../variables";

@Injectable({
  providedIn: "root",
})
export class ProductsService {
  protected basePath = environment.apiV2RootUrl;
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== "string") {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== "string") {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(
    httpParams: HttpParams,
    value: any,
    key?: string,
  ): HttpParams {
    if (typeof value === "object" && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(
    httpParams: HttpParams,
    value?: any,
    key?: string,
  ): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === "object") {
      if (Array.isArray(value)) {
        (value as any[]).forEach(
          (elem) =>
            (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)),
        );
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(
            key,
            (value as Date).toISOString().substring(0, 10),
          );
        } else {
          throw Error("key may not be null if value is Date");
        }
      } else {
        Object.keys(value).forEach(
          (k) =>
            (httpParams = this.addToHttpParamsRecursive(
              httpParams,
              value[k],
              key != null ? `${key}.${k}` : k,
            )),
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error("key may not be null if value is not object or array");
    }
    return httpParams;
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiProductsMenuGet(
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<ProductMenuVM>>;
  public apiProductsMenuGet(
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<ProductMenuVM>>>;
  public apiProductsMenuGet(
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<ProductMenuVM>>>;
  public apiProductsMenuGet(
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    // authentication (Bearer) required
    const localVarCredential = this.configuration.lookupCredential("Bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set(
        "Authorization",
        localVarCredential,
      );
    }

    let localVarHttpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected,
      );
    }

    let localVarHttpContext: HttpContext | undefined =
      options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined =
      options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/api/products/menu`;
    localVarPath = localVarPath.replace("/api", "");
    return this.httpClient.request<Array<ProductMenuVM>>(
      "get",
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiProductsByZipCodeGet(
    zipCode: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ProductCodeVm>;
  public apiProductsByZipCodeGet(
    zipCode: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<ProductCodeVm>>;
  public apiProductsByZipCodeGet(
    zipCode: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<ProductCodeVm>>;
  public apiProductsByZipCodeGet(
    zipCode: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    // authentication (Bearer) required
    const localVarCredential = this.configuration.lookupCredential("Bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set(
        "Authorization",
        localVarCredential,
      );
    }

    let localVarHttpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected,
      );
    }

    let localVarHttpContext: HttpContext | undefined =
      options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined =
      options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    const localVarPath = `/products/zipcode/${zipCode}/code`;

    return this.httpClient.request<ProductCodeVm>(
      "get",
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiProductReferenceGet(
    productCode: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<BaremeResponse>;
  public apiProductReferenceGet(
    productCode: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<BaremeResponse>>;
  public apiProductReferenceGet(
    productCode: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<BaremeResponse>>;
  public apiProductReferenceGet(
    productCode: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    // authentication (Bearer) required
    const localVarCredential = this.configuration.lookupCredential("Bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set(
        "Authorization",
        localVarCredential,
      );
    }

    let localVarHttpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected,
      );
    }

    let localVarHttpContext: HttpContext | undefined =
      options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined =
      options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    const localVarPath = `/products/${productCode}/productreference`;

    return this.httpClient.request<ProductCodeVm>(
      "get",
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }
}
